import styled, { css } from 'styled-components';

const Container = styled.div<{
    $webapp: boolean;
}>`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    z-index: 11;
    width: 100vw !important;
    height: 100vh !important;
    top: 0;

    ${props => props.$webapp && css`
        max-width: 600px;
    `};
`;

const Spinner = styled.img`
    animation: pulse 0.7s infinite;
    animation-direction: alternate;
    -webkit-animation-name: pulse;
    animation-name: pulse;
    width: 120px;

    @-webkit-keyframes pulse {
        0% {
            -webkit-transform: scale(1);
        }
        100% {
            -webkit-transform: scale(1.1);
        }
    }

    @keyframes pulse {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(1.1);
        }
    }
`;

export { Container, Spinner };